import apiClient from "./index";
import { Category } from "../types";
import { ApiResponse } from "./auth";
import { handleApiError } from "../utils/utils";

export const getCategories = async (): Promise<ApiResponse<Category[]>> => {
  try {
    const response = await apiClient.get("/categories");
    return { data: response.data, error: null };
  } catch (error) {
    return handleApiError(
      error,
      "An unknown error occurred during fetching categories."
    );
  }
};
